// redesign-base.js
// Global JS for the redesign layout (layout/redesign.liquid).

(function () {
  'use strict';

  var toggle = document.querySelector('.pm-header-nav-toggle');
  var nav = document.getElementById('PmHeaderNav');

  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var isOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!isOpen));
      nav.classList.toggle('is-open', !isOpen);
      document.body.classList.toggle('pm-nav-open', !isOpen);
    });

    // close on Escape
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && nav.classList.contains('is-open')) {
        toggle.setAttribute('aria-expanded', 'false');
        nav.classList.remove('is-open');
        document.body.classList.remove('pm-nav-open');
        toggle.focus();
      }
    });

    // closes one submenu item: itself, plus anything left open nested
    // inside it (so reopening it later doesn't show stale expanded state)
    function closeItem(item) {
      item.classList.remove('is-open');
      var itemButton = item.querySelector('.pm-header-menu__link--parent');
      if (itemButton) itemButton.setAttribute('aria-expanded', 'false');
      item.querySelectorAll('.pm-header-menu__item--has-submenu.is-open').forEach(function (nestedItem) {
        nestedItem.classList.remove('is-open');
        var nestedButton = nestedItem.querySelector('.pm-header-menu__link--parent');
        if (nestedButton) nestedButton.setAttribute('aria-expanded', 'false');
      });
    }

    // mobile accordion: parent links with a submenu toggle open/closed
    // instead of navigating (desktop uses hover, handled purely in CSS).
    // querySelectorAll + closest() here aren't level-specific — they match
    // whichever ".pm-header-menu__item--has-submenu" is nearest to the
    // button that was clicked, so this already works at level 2, level 3,
    // or any further nesting without changes, as long as the Liquid/CSS
    // give every level that same "--has-submenu" class (see
    // header-redesign.liquid / redesign-header.css).
    // must match the mobile breakpoint in redesign-header.css
    // (currently "@media (max-width: 1360px)")
    var MOBILE_QUERY = '(max-width: 1360px)';

    var parentLinks = nav.querySelectorAll('.pm-header-menu__link--parent');
    parentLinks.forEach(function (button) {
      // Stop a plain mouse click from leaving the button focused. Desktop
      // CSS shows the dropdown on ":hover" OR ":focus-within" (the
      // focus-within is there so keyboard/Tab users can open it too) —
      // but a mouse click also focuses the button, so without this,
      // moving the mouse away ends :hover yet :focus-within stays true
      // and the dropdown never closes until you click elsewhere on the
      // page. preventDefault() on mousedown blocks that default focus
      // WITHOUT blocking the click event itself, so keyboard Tab focus
      // (which doesn't fire mousedown) still works normally.
      button.addEventListener('mousedown', function (event) {
        var isMobile = window.matchMedia(MOBILE_QUERY).matches;
        if (!isMobile) event.preventDefault();
      });

      button.addEventListener('click', function () {
        var item = button.closest('.pm-header-menu__item--has-submenu');
        if (!item) return;

        var isMobile = window.matchMedia(MOBILE_QUERY).matches;
        if (!isMobile) return; // desktop dropdown is hover/focus only

        var isOpen = item.classList.contains('is-open');

        if (isOpen) {
          // clicking an already-open item closes it (and anything open
          // inside it)
          closeItem(item);
          return;
        }

        // opening this item — close any SIBLING item at the same level
        // that's currently open, so only one submenu per level is open
        // at a time instead of stacking up
        var siblingList = item.parentElement;
        if (siblingList) {
          for (var i = 0; i < siblingList.children.length; i++) {
            var sibling = siblingList.children[i];
            if (
              sibling !== item &&
              sibling.classList.contains('pm-header-menu__item--has-submenu') &&
              sibling.classList.contains('is-open')
            ) {
              closeItem(sibling);
            }
          }
        }

        button.setAttribute('aria-expanded', 'true');
        item.classList.add('is-open');
      });
    });
  }
})();